(function (module) {
    "use strict";
  
    module.service("monthlyDataService", [function(this: $TSFixMe) {
        var service = this;
  
        service.fitDataBetweenDates = function(startDate: $TSFixMe, endDate: $TSFixMe, dataStartDate: $TSFixMe, data: $TSFixMe) {

            const startDateYear = startDate.getFullYear();
            const endDateYear = endDate.getFullYear();
            const dataStartDateYear = !dataStartDate 
                ? startDateYear 
                : dataStartDate.getFullYear();

            const yearsBeforeDataStart = Math.max(0, dataStartDateYear - startDateYear);
            const dataYearsBeforeStartYear = Math.max(0, startDateYear - dataStartDateYear);
            const desiredYears = endDateYear - startDateYear + 1;

            const beforeDataStart = Array(12 * yearsBeforeDataStart).fill(0);
            const dataAfterStartDateYeaer = data.slice(12 * dataYearsBeforeStartYear);
            const afterDataEnd = Array(12 * dataYearsBeforeStartYear).fill(0);

            return beforeDataStart
                .concat(dataAfterStartDateYeaer)
                .concat(afterDataEnd)
                .slice(0, 12 * desiredYears);

        };
      },
    ]);

  })(angular.module("topline.services"));
  